export enum SaveType {
    NOT = 0,
    DEVICE = 1,
    COPY = 2
}

export enum MessageBoxType {
    DEFAULT = 0,
    SUCCESS = 1,
    IFRAME = 2,
    PE_INPUT = 3
}

export enum PopupMenu {
    NONE = 0,
    CAMERA = 1,
    FLOORPLAN = 2,
    FLOORPLAN_IN_TAB = 3,
    FLOORPLAN_SETUP = 4,
    LOGIN = 5,
    GROUND_SETUP = 6,
    SOLIDFLOOR_SETUP = 7,
    CATALOG = 8,
    PROJECT_SORT = 9
}

export enum HamburgerTab {
    MENU = 0,
    DEBUG = 1,
    HELP_FAQ = 2,
    HELP_ICONS = 3,
    HELP = 4,
    LOGIN = 6,
    SETTINGS = 7,
    SETTINGS_IMAGE = 8,
}

export enum SidebarModule {
    NONE = 0,
    CATALOG = 2,
    PROPERTIES = 3,
    ARTICLELIST = 4,
    SHARE = 5,
    INSPIRATIONS = 6,
    ROOM = 7,
    SHARE_MAIL = 8,
    SHARE_DL = 9,
    SHARE_APP = 10,
    SHARE_FORMULAR = 11,
}

export enum Overlay {
    NONE = 0,
    PENDING = 1,
    LOGIN = 3,
    LOGIN_QUESTION = 4,
    IMAGES = 5,
    FLOORPLAN = 6,
}

export enum ReadOnly {
    Disabled,
    Reopen,
    Save
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/Enums.ts